/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Invite_BodyInputs */

const en_us2_body_assessment_invite_body = /** @type {(inputs: Body_Assessment_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two photos, front and side, turn into a waist-to-height ratio and a body-fat estimate. Take them again now and then and the direction shows.`)
};

const pt_br2_body_assessment_invite_body = /** @type {(inputs: Body_Assessment_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas fotos, de frente e de lado, viram uma relação cintura/altura e uma estimativa de gordura corporal. Refazendo de vez em quando, dá para ver a direção.`)
};

const es_419_body_assessment_invite_body = /** @type {(inputs: Body_Assessment_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos fotos, de frente y de lado, se convierten en una relación cintura/estatura y una estimación de grasa corporal. Repítelas de vez en cuando y se ve la dirección.`)
};

const pt_pt2_body_assessment_invite_body = /** @type {(inputs: Body_Assessment_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas fotos, de frente e de lado, tornam-se uma relação cintura/altura e uma estimativa de gordura corporal. Repetindo de vez em quando, vês a direção.`)
};

const fr_fr2_body_assessment_invite_body = /** @type {(inputs: Body_Assessment_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux photos, de face et de profil, donnent un rapport tour de taille/taille et une estimation de masse grasse. Refais-les de temps en temps et la tendance apparaît.`)
};

const de_de2_body_assessment_invite_body = /** @type {(inputs: Body_Assessment_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus zwei Fotos, von vorne und von der Seite, werden ein Taille-Größe-Verhältnis und eine Körperfettschätzung. Wiederhol sie ab und zu, dann zeigt sich die Richtung.`)
};

const it_it2_body_assessment_invite_body = /** @type {(inputs: Body_Assessment_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due foto, frontale e laterale, diventano un rapporto vita/altezza e una stima del grasso corporeo. Rifacendole ogni tanto, si vede la direzione.`)
};

/**
* | output |
* | --- |
* | "Two photos, front and side, turn into a waist-to-height ratio and a body-fat estimate. Take them again now and then and the direction shows." |
*
* @param {Body_Assessment_Invite_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_invite_body = /** @type {((inputs?: Body_Assessment_Invite_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Invite_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_invite_body(inputs)
	if (locale === "es-419") return es_419_body_assessment_invite_body(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_invite_body(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_invite_body(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_invite_body(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_invite_body(inputs)
	return en_us2_body_assessment_invite_body(inputs)
});
export { body_assessment_invite_body as "body-assessment.invite_body" }